var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 7.5,
    transform: "rotate(90 15.5 0.5)",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.93188 4L7.93188 11.6344",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2824 8.36951L8.01662 11.6353L4.75081 8.36951",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.301987830fe8ecfc5a1d5bef7a414f72.svg";
export { ForwardRef as ReactComponent };